import ShopList from './ShopList'
import UpdateStatus from './UpdateStatus'

export default {
  ShopList,
  UpdateStatus
}



// WEBPACK FOOTER //
// ./src/components/ShopPayment/index.js